import { Link } from 'gatsby';
import React from 'react';
import './Card.scss';


const Card = ({link, parentTitle, cardTitle, image, children}) => {
  const style = {
    backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 66%, rgba(0,0,0,0.9) 100%), url(${image})`,
  };

  return (
    <div id='Card'>
      <Link to={link}>
        <div className="color-block" style={style}>
          <p>{parentTitle}</p>
        </div>
        <div className="content">
          <h3>{cardTitle}</h3>
            <div className="text">
            {children}
            </div>
        </div>
      </Link>
    </div>
  )
}

export default Card